export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/60">
          <div className="flex-shrink-0">
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-2xl overflow-hidden flex items-center justify-center">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20dark%20app%20icon%20design%20with%20crimson%20and%20gold%20gradient%2C%20gossip%20news%20app%20icon%20aesthetic%2C%20modern%20flat%20design%20with%20dramatic%20lighting%20accent%2C%20clean%20simple%20composition%20on%20dark%20background%2C%20professional%20app%20icon%20quality&width=400&height=400&seq=app-icon-2026&orientation=squarish"
                alt="每日大赛黑料APP图标"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              加入黑料吃瓜群
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              扫码加入每日大赛黑料吃瓜群，第一时间获取独家大赛内幕推送。大赛吃瓜、黑料围观、每日吃瓜爆料，吃瓜群众不容错过的专属社群入口。
            </p>
            <div className="mt-5 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-smartphone-line mr-2"></i>iOS / Android 下载
              </button>
              <button className="px-6 py-2.5 border border-secondary-300 hover:border-primary-400 text-foreground-700 font-medium rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-wechat-line mr-2"></i>微信小程序入口
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}